module.exports = {
  "dof-tag-group": {
    "flexDirection": "column"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-90aca82e!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-tag-group/index.vue
// module id = 522
// module chunks = 0 1